export default getStoredLanguage;

function getStoredLanguage() {
  let language = sessionStorage.getItem('language');
  if (!language) {
    language = 'it';
    sessionStorage.setItem('language', language);
  }
  return language;
}

export function storeLanguage(lang) {
  sessionStorage.setItem('language', lang);
}
